import { CategoryPage } from '@/components/marketplace/categoryPage';
import { MarketplaceBreadcrumb } from '@/components/marketplace/marketplaceBreadcrumb';
import { ProductPage } from '@/components/marketplace/productPage';
import { SubCategoryPage } from '@/components/marketplace/subCategoryPage';
import { MetaHead } from '@/components/shared/metaHead';
import { SchemaHead } from '@/components/shared/schemaHead';
import ToastProvider from '@/components/shared/toast/ToastContainer';
import { ICategoryData, IMetaHead, IPageMenu, IProductData, ISubCategoryData } from '@/interfaces';
import { useGlobalContext } from '@/lib/context';
import blogService from '@/lib/services/blogService';
import marketPlaceService from '@/lib/services/marketPlaceService';
import { GetServerSideProps } from 'next';
import React, { useEffect } from 'react';
type props = {
    categoryData: ICategoryData
    productDetails: IProductData
    subCatData: ISubCategoryData
    navSchemaData: IPageMenu[]
    marketPlaceNavSchema: IPageMenu[]
}
const MktCategoryPage = ({ categoryData, productDetails, subCatData, navSchemaData, marketPlaceNavSchema }: props) => {
    const categoryDetails = categoryData?.categoryData || {};
    const metaDetails = categoryData?.categoryData?.metaDetails || {};
    const isProductPage = productDetails && Object.keys(productDetails).length > 0 || false
    categoryDetails ? categoryDetails.metaDetails = (metaDetails || []) : null;
    const baseUrl = process.env.SITE_URL;
    const selectedValues = (subCatData?.filters?.flatMap(filter => 
        filter.attributeValues
          .filter(attr => attr.isSelectedAttributeValue)
          .map(attr => attr.attributeValue)
      ) || [])?.join(' ') || "";
   
    const getBreadCrumbJson = () => {
        let breadCrumJson = [];
        if (categoryData && Object.keys(categoryData).length > 0) {
            breadCrumJson.push({
                name: `${categoryDetails.serviceName}`,
                url: ''
            })
        } else if (subCatData && Object.keys(subCatData).length > 0) {
            breadCrumJson.push({
                name: `${subCatData.categoryName}`,
                url: `${baseUrl}/online-store/${subCatData.serviceSlug}/${subCatData.categorySlug}`
            }, {
                name: `${selectedValues} ${subCatData.categoryName}`,
                url: ``
            }
            )
        } else {
            breadCrumJson.push({
                name: `${productDetails.serviceName}`,
                url: `${baseUrl}/online-store/${productDetails.serviceSlug}`
            }, {
                name: `${productDetails.categoryName}`,
                url: `${baseUrl}/online-store/${productDetails.serviceSlug}/${productDetails.categorySlug}`
            }, {
                name: `${productDetails.productName}`,
                url: ``
            })
        }
        return breadCrumJson
    };
    const metaData: IMetaHead = {
        title: "",
        description: "",
        pageGroup:""
    };
    if (isProductPage) {
        metaData['title'] = `Buy ${productDetails?.productName} Online in India`;
        metaData['description'] = `Shop ${productDetails?.productName} online at best price in India from Interior Company. Check out great deals and discounts on various ${`${productDetails.serviceName}/${productDetails.categoryName}`}, buy the desired one and spruce up Your home decor. ✔Quality Products ✔Exquisite Designs`;
        metaData['pageGroup'] = 'ONLINE-STORE-PRODUCT-PAGE';
    } else if (categoryData && Object.keys(categoryData).length > 0) {
        metaData['title'] = !categoryDetails.maxDiscount ? metaDetails?.meta_title?.split('-')[0] : metaDetails?.meta_title?.replaceAll(/{(.*?)}/g, categoryDetails.maxDiscount) || '';
        metaData['description'] = metaDetails?.meta_description || '';
    } else if (subCatData && Object.keys(subCatData).length > 0) {
        metaData['title'] = subCatData.metaDetails?.meta_title || '';
        metaData['description'] = subCatData.metaDetails?.meta_description || '';
        metaData['pageGroup'] = 'ONLINE-STORE-FILTER-PAGE';
    };
    const schemaData = [];
    if (isProductPage) {
        const productImages = productDetails?.productDetail?.files?.map((f) => `"${f.filePath}"`) || "";
        schemaData.push({
            __html: `
        {
          "@context": "https://schema.org/", 
          "@type": "Product", 
          "name": "${productDetails?.productName}",
          "image": [${productImages}],
         "description": "Shop ${productDetails?.productName} online at best price in India from Interior Company. Check out great deals and discounts on various ${`${productDetails?.serviceName}/${productDetails?.categoryName}`}, buy the desired one and spruce up Your home decor. ✔Quality Products ✔Exquisite Designs",
        "sku": "${productDetails?.productDetail?.skuId}",
        "brand": {
            "@type": "Brand",
            "name": "${productDetails?.productDetail?.brandName}"
          },
          "offers": {
            "@type": "Offer",
            "url": "${`${baseUrl}/online-store/${productDetails?.productSlug}`}",
            "priceCurrency": "INR",
            "price": "${productDetails?.productDetail?.offerPrice}",
            "availability": "https://schema.org/InStock",
            "itemCondition": "https://schema.org/NewCondition",
            "seller":{
        "@type":"Organization",
        "name":"Interior Company"
              }
          }
        }
        `})
    } else if (categoryData && Object.keys(categoryData).length > 0) {
        const faqData = () => {
            const faqs = []
            if (metaDetails && metaDetails.FAQ && metaDetails.FAQ.FAQ)
                for (const d of metaDetails.FAQ.FAQ) {
                    faqs.push(`{
                  "@type":"Question",
                  "name":"${d.question}",
                  "acceptedAnswer":{
                  "@type":"Answer",
                  "text":"${d.answer.replace(new RegExp('<[^>]*>', 'g'), ' ').replace(/(\s\s\s*)/g, ' ').replace("&#8217;", "'")}"}
                }`)
                }
            return faqs
        }
        faqData().length > 0 && schemaData.push(
            {
                __html: `
                 {
               "@context": "http://schema.org/",
               "@type":"FAQPage",
               "mainEntity" : [${faqData()}]
        }
        `})
    }
    const { funs: { toggleFloatingWidget } } = useGlobalContext();
    useEffect(() => {
        toggleFloatingWidget(true);
    }, [])
    return (<>
        <ToastProvider>
            <MetaHead metaData={metaData} />
            <MarketplaceBreadcrumb breadCrumbJson={getBreadCrumbJson()} />
            <SchemaHead data={schemaData} navSchemaData={[...navSchemaData, ...marketPlaceNavSchema]} />
            {
                categoryData && Object.keys(categoryData).length > 0 && <CategoryPage catProducts={categoryDetails} />
            }
            {
                subCatData && Object.keys(subCatData).length > 0 && <SubCategoryPage data={subCatData} marketingBanner={[]} />
            }
            {
                productDetails && Object.keys(productDetails).length > 0 && <ProductPage productData={productDetails} />
            }
        </ToastProvider>
    </>
    )
}
export const getServerSideProps: GetServerSideProps = async (context) => {
    const slug: any = context?.params?.category || '';
    if (slug.includes('pid_')) {
        const productDetails = await marketPlaceService.getProductDetails(slug);
        const loginToken: string = JSON.parse(context.req.cookies.LOGIN || "{}").token || "";
        let cartProductDetails; 
        if (loginToken) {
            const cart = await marketPlaceService.getCart("city", "gurgaon", loginToken);
            if (cart && Object.keys(cart).length > 0) {
                cartProductDetails = cart
            }
        } else {
            const cartItems: [{ productId: number; quantity: number; isProductSelected: boolean; }] = JSON.parse(context.req.cookies.cart || "[]") || "";
            const body = {
                CityName: "Delhi",
                ListProduct: cartItems
            }
            const preLoginCart = await marketPlaceService.getCartProductDetails(body);
            if (preLoginCart && Object.keys(preLoginCart).length > 0) {
                cartProductDetails = preLoginCart
            }
        }
        const isProductIsIncart = cartProductDetails?.productList?.findIndex((f: any) => f.productId === productDetails.productId) != -1 || false;
        Object.keys(productDetails).length > 0 ? productDetails.isProductIsIncart = isProductIsIncart : null;
        const payUOfferList = await marketPlaceService.getPayUOfferList();
        payUOfferList && Object.keys(payUOfferList).length > 0 ? productDetails.payUOfferList = payUOfferList : [];
        if (!Object.keys(productDetails?.productDetail || {}).length)
            return { notFound: true }
        return {
            props: { productDetails }
        };
    } else if (slug.includes('-online-')) {
        if (context.query.page && (isNaN(Number(context.query.page)) || Number(context.query.page) < 1)) {
            return {
                notFound: true,
            };
        }
        const pageNo = context.query.page || 1;
        const body = {
            "CityName": "Delhi",
            "FilterBasedUrl": slug,
            "PageSize": 16,
            "PageNo": pageNo
        }
        const subCatData = await marketPlaceService.getSubCategoryData(body);
        if (subCatData && Object.keys(subCatData).length > 0) {
            const subCategorySlug = subCatData.categorySlug;
            const attr = subCatData.categoryIdentifier +'-'+slug.split('-'+subCatData.categoryIdentifier+'-')[1];
            {
                const specificPageMeta = await blogService.getMarketPlaceSeoContent(slug);
                if (specificPageMeta && Object.keys(specificPageMeta).length > 0) {
                    subCatData.metaDetails = specificPageMeta
                } else {
                    const metaDetails = await blogService.getMarketPlaceFilterMeta(subCategorySlug, attr);
                    const productCount = subCatData?.pagination?.totalRows || 0;
                    if (metaDetails) {
                        subCatData.filters && subCatData.filters.map((f: any) => {
                            if (f.isGenerateFilterUrl == 1) {
                                f.attributeValues.map((a: any) => {
                                    if (a.isSelectedAttributeValue === 1) {
                                        metaDetails.heading = metaDetails?.heading?.replaceAll(`{${f.attributeNameSlug.toUpperCase()}}`, `${a.attributeValue}`)?.replaceAll(`{NUMBER}`, `${productCount}`)?.replaceAll(`{DISCOUNT}`, `${subCatData.maxDiscount}`) || '';
                                        metaDetails.meta_title = metaDetails?.meta_title?.replaceAll(`{${f.attributeNameSlug.toUpperCase()}}`, `${a.attributeValue}`)?.replaceAll(`{NUMBER}`, `${productCount}`)?.replaceAll(`{DISCOUNT}`, `${subCatData.maxDiscount}`) || '';
                                        metaDetails.meta_description = metaDetails?.meta_description?.replaceAll(`{${f.attributeNameSlug.toUpperCase()}}`, `${a.attributeValue}`)?.replaceAll(`{NUMBER}`, `${productCount}`)?.replaceAll(`{DISCOUNT}`, `${subCatData.maxDiscount}`) || '';
                                        metaDetails.short_content = metaDetails?.short_content?.replaceAll(`{${f.attributeNameSlug.toUpperCase()}}`, `${a.attributeValue}`)?.replaceAll(`{NUMBER}`, `${productCount}`)?.replaceAll(`{DISCOUNT}`, `${subCatData.maxDiscount}`) || '';
                                    }
                                })
                            }
                            return f
                        })
                    }
                    subCatData.metaDetails = metaDetails
                }
            }
        }
        if (!Object.keys(subCatData).length)
            return { notFound: true }
        return {
            props: { subCatData }
        }
    } else {
        const categoryData = await marketPlaceService.getCategoryData(slug);
        if (categoryData && Object.keys(categoryData).length > 0) {
            const metaDetails = await blogService.getMarketPlaceSeoContent(slug);
            const marketingBanner = await blogService.getMarketingBanners('cat') || [];
            categoryData.marketingBanner = marketingBanner
            categoryData.metaDetails = metaDetails
        }
        if (!Object.keys(categoryData).length)
            return { notFound: true }
        return {
            props: {
                categoryData: {
                    categoryData
                }
            }
        }
    }

}
export default MktCategoryPage;